import { color } from 'd3-color';

const getAverageColor = (firstColor, lastColor) => {
  if (firstColor === lastColor) {
    return firstColor;
  }

  const first = color(firstColor);
  const last = color(lastColor);

  if (!first || !last) {
    var _ref, _first$toString;

    return (_ref = (_first$toString = first === null || first === void 0 ? void 0 : first.toString()) !== null && _first$toString !== void 0 ? _first$toString : last === null || last === void 0 ? void 0 : last.toString()) !== null && _ref !== void 0 ? _ref : '';
  }

  const {
    r: r1,
    g: g1,
    b: b1
  } = first.rgb();
  const {
    r: r2,
    g: g2,
    b: b2
  } = last.rgb();
  return `rgb(${Math.round((r1 + r2) / 2)},${Math.round((g1 + g2) / 2)},${Math.round((b1 + b2) / 2)})`;
};

export { getAverageColor };
